import { trust } from '@dnajs/idom';

<ul>
    {this.groups.map((group) =>
        <li data-group={group.name} data-active-group={this.activeGroup === group.name}>
            <button><span>{trust(group.label)}</span></button>
        </li>
    )}
</ul>;